import { Map } from "immutable";

import type { TranslatableMap } from "./models";

// import en from "react-intl/locale-data/en";
// import fr from "react-intl/locale-data/fr";

class Localisation {
    /**
     * Initlise react-intl locales
     *
     * @return void
     */
    public static initialiseReactIntl(): void {
        // We don't need to do this in newer versions of react-intl
        // addLocaleData([...en, ...fr]);
    }

    /**
     * Language is a valid locale.
     *
     * @param string language
     * @return boolean
     */
    public static validLocale(language: string): boolean {
        return language === "en" || language === "fr" || language === "jo";
    }

    /**
     * Function to get the language set on the browser.
     *
     * @param boolean withRegionCode - Whether the region code should be included.
     * @return string
     */
     public static getBrowserLanguage(withRegionCode: boolean = true): string {
         let lang = navigator.language ? navigator.language : "en-GB";
         if (!withRegionCode) {
             lang = Localisation.stripRegionFromLanguage(lang);
         }
         return lang;
     }

     /**
      * Strip the region code from the full language.
      *
      * @param string lang
      * @return string
      */
     public static stripRegionFromLanguage(lang: string): string {
         return lang.toLowerCase().split(/[_-]+/)[0];
     }

    /**
     * Determines whether the given object is a TranslatableMap.
     *
     * @param object any - The object to test
     * @return object is a TranslatableMap
     */
    public static instanceOfTranslatableMap(object: any): object is TranslatableMap {
        return object != null && object.en !== undefined;
    }

     /**
      * Returns the correct translation from a TranslatableMap object.
      *
      * @param TranslatableMap map - The map to translate
      * @param string lang = null - The language to use, default to the browser language
      * @return string
      */
     public static translateMap(map: TranslatableMap, lang: string = null): string {
         // Default to the browser language.
         if (lang === null) {
             lang = Localisation.getBrowserLanguage(false);
         }

         // If it's an immutable map, convert it to an object.
         if (Map.isMap(map)) {
             map = (map as unknown as Map<string, any>).toJS();
         }

         if (lang in map) {
             return map[lang];
         }
         // If it's not in, default to english.
         else if ("en" in map) {
             return map.en;
         }
         // Shouldn't happen but return the first otherwise.
         else {
             const indexes = Object.keys(map);
             if (indexes.length > 0) {
                 return map[indexes[0]];
             }
             else {
                 return null;
             }
         }
     }
}

export {
    Localisation,
    TranslatableMap,
};
